import type { PublicSiteConfig } from './api.js';

/**
 * Boot snapshot key is HOST-scoped (not tenant-scoped via storageKey): the
 * tenantId is unknown until the first /site-config response, so the only
 * stable key at first paint is the origin host.
 */
export function snapshotKey(host: string): string {
  return `b1fr0st.player.siteconfig.${host}`;
}

export function readSnapshot(host: string): PublicSiteConfig | null {
  try {
    const raw = localStorage.getItem(snapshotKey(host));
    return raw ? (JSON.parse(raw) as PublicSiteConfig) : null;
  } catch {
    return null;
  }
}

export function writeSnapshot(host: string, cfg: PublicSiteConfig): void {
  try {
    localStorage.setItem(snapshotKey(host), JSON.stringify(cfg));
  } catch {
    // ignore quota / private-mode failures
  }
}
